import { NgModule } from '@angular/core';
import { RolePermissionPlugin } from './role-permission/role-permission.plugin';
import { UserRolePlugin } from './user-role/user-role.plugin';
import { AbstractPluginsModule } from '../../plugins/abstract-plugins/list/abstract-plugins.module';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [ CommonModule, AbstractPluginsModule ],
    exports: [],
    declarations: [ RolePermissionPlugin, UserRolePlugin ],
    entryComponents: [ RolePermissionPlugin, UserRolePlugin ],
    providers: [],
})
export class AuthenticationPluginsModule {
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/plugins/authentication-plugins.module.ts